var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component"},[_c('keep-alive',{key:_vm.keepAliveKey,attrs:{"include":_vm.cachedComponents}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }